import React from "react";
import { makeStyles } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { PaginationWrapper } from "./styles";
var useStyles = makeStyles(function (theme) { return ({
    ul: {
        "& .Mui-selected": {
            backgroundColor: theme.palette.primary.main
        }
    }
}); });
export var TablePagination = function (_a) {
    var currentPage = _a.page, count = _a.count, rowsPerPage = _a.rowsPerPage, _b = _a.shape, shape = _b === void 0 ? "rounded" : _b, onChange = _a.onChange;
    var classes = useStyles();
    var totalPages = Math.ceil(count / rowsPerPage);
    return (React.createElement(PaginationWrapper, null,
        React.createElement(Pagination, { classes: { ul: classes.ul }, page: currentPage, size: "medium", count: totalPages, shape: shape, onChange: function (event, page) {
                if (currentPage !== page) {
                    onChange(event, page);
                }
            } })));
};
//# sourceMappingURL=TablePagination.js.map